import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Garantizado } from '../../services/garantizados.service';

@Component({
  selector: 'app-detalle-meta-dialog',
  templateUrl: './detalle-meta-dialog.component.html',
  styleUrls: ['./detalle-meta-dialog.component.scss']
})
export class DetalleMetaDialogComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public data: {
    garantizado: Garantizado,
    vendedorNombre: string
  }) { }
}
